import { createSelector } from 'reselect';
import { StudioSection } from '../../types/store';
import { getActiveSection, getSelectedFolder, getStudioParams } from './page';

export const getIsRootStashFolder = createSelector(
  [getActiveSection, getStudioParams, getSelectedFolder],
  (activeSection, params, selectedFolder) =>
    activeSection === StudioSection.STASH && !selectedFolder?.parentId && !params.subfolderId
);
